
import { StatementTable } from "components/statement-components/StatementTable";
import { StatementChart } from "components/statement-components/StatementChart";
import { StatementHead } from "components/statement-components/StatementHead";
import { StatementStatistics } from "components/statement-components/StatementStatistics";
import { LoadingPage } from "components/widget/Loader/LoadingPage";
import { useAccountDashboard } from "hooks/dashboard-hooks"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom";
import { StatementFooterTable } from "components/statement-components/StatementFooterTable";

export const Statement = () => {
    let parms = useParams()
    const { data: accountData, refetch, isLoading } = useAccountDashboard('10')


    return (
        <>
            <div className="flex flex-col w-full">

                <StatementHead
                    balance={accountData?.data?.data?.balance}
                    username={accountData?.data?.data?.username}
                    user_data={accountData?.data?.data?.user_data}
                    metrics={accountData?.data?.data?.data?.data?.metrics}
                />
                <div className="flex flex-col w-full px-5 mt-2 md:mt-4">
                    <StatementTable
                        trades={accountData?.data?.data?.data?.data?.trades}
                    />
                    <StatementFooterTable
                        metrics={accountData?.data?.data?.data?.data?.metrics}
                        trades={accountData?.data?.data?.data?.data?.trades}
                    />
                </div>

                <div className="flex flex-col w-full px-5 mt-4 md:mt-8">
                    <div className="flex flex-wrap w-full ">
                        <StatementStatistics
                            metrics={accountData?.data?.data?.data?.data?.metrics}
                            trades={accountData?.data?.data?.data?.data?.trades}
                            statics={accountData?.data?.data?.statics}
                        />
                    </div>
                </div>

                <div className="flex flex-col w-full px-5 mt-2 md:mt-4">
                    <div className="relative flex justify-center w-full pl-0 md:pl-2">
                        <img src="/assets/layout/pattern.png" className="absolute  h-full py-[50px] " />
                        <StatementChart
                            days={accountData?.data?.data?.data?.data?.analyze?.days}
                        />
                    </div>
                </div>

            </div>

            {isLoading && <LoadingPage />}


        </>
    )
}